import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class CellularAutoDialerDto extends InspectionCase {
  item_5_1?: InspectionCase;
  item_5_2?: InspectionCase;
  item_5_3?: InspectionValueCase;
  item_5_4?: InspectionValueCase;
  item_5_5?: InspectionCase;
}

export class CellularAutoDialer extends CellularAutoDialerDto {
  constructor(
    data: CellularAutoDialerDto = { title: 'חייגן אוטומטי סלולארי' }
  ) {
    super(data);
    this.item_5_1 = new InspectionCase({
      ...data.item_5_1,
      title: `ניתן להשתמש בטלפון סלולרי רק באתרים ללא תשתית לקו טלפון העונה לדרישות התקן בכפוף לתנאים הבאים`
    });
    this.item_5_2 = new InspectionCase({
      ...data.item_5_2,
      title: `קיים גיבוי מתח ליחידה הסלולארית למשך 25 שעות`
    });
    this.item_5_3 = new InspectionValueCase({
      ...data.item_5_3,
      title: 'זרם נמדד'
    });
    this.item_5_4 = new InspectionValueCase({
      ...data.item_5_4,
      title: 'גודל מצברים'
    });
    this.item_5_5 = new InspectionCase({
      ...data.item_5_5,
      title:
        'קיים בקרה על קו הטלפון לרבות עוצמת קליטה ניתן לנתק את האנטנה לקבלת חיווי'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_5_1.isApplicable || this.item_5_1.isPassed) &&
        (!this.item_5_2.isApplicable || this.item_5_2.isPassed) &&
        (!this.item_5_3.isApplicable || this.item_5_3.isPassed) &&
        (!this.item_5_4.isApplicable || this.item_5_4.isPassed) &&
        (!this.item_5_5.isApplicable || this.item_5_5.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_5_1.getNotes(),
      ...this.item_5_2.getNotes(),
      ...this.item_5_3.getNotes(),
      ...this.item_5_4.getNotes(),
      ...this.item_5_5.getNotes()
    ];
  }
}
